import { createSlice } from '@reduxjs/toolkit';
import {
  fetchModules,
  fetchModuleByID,
  fetchModulesDropdownsList,
  updateModules,
  updateModulesStatus
} from './thunk';

interface ModuleState {
  modulesList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedOrganisation: any;
  appNameDropDown: any[];
  industryTypeDropDown: any[];
  orgCityDropDown: any[];
  orgStateDropDown: any[];
  pincodeDropDown: any[];
  exportCSVLoading: boolean;
  exportCSVError: string | null;
  allModules:any[] | null;
}

const initialState: ModuleState = {
  modulesList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedOrganisation: null,
  appNameDropDown: [],
  industryTypeDropDown: [],
  orgCityDropDown: [],
  orgStateDropDown: [],
  pincodeDropDown: [],
  exportCSVLoading: false,
  exportCSVError: null,
  allModules:[]
};

const modulesSlice = createSlice({
  name: 'modules',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      // Fetch All Organisations
      .addCase(fetchModules.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchModules.fulfilled, (state, action) => {
        state.loading = false
        state.modulesList = Array.isArray(action.payload.data)
          ? action.payload.data
          : []
        state.rowCount =
          typeof action.payload.rowCount === 'number'
            ? action.payload.rowCount
            : 0
      })
      .addCase(fetchModules.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to fetch organisations'
      })

        //   // Fetch the dropdown of app modules
      .addCase(fetchModulesDropdownsList.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchModulesDropdownsList.fulfilled, (state, action) => {
        state.loading = false
         state.allModules = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchModulesDropdownsList.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })

      // Fetch Single Organisation by ID
      .addCase(fetchModuleByID.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchModuleByID.fulfilled, (state, action) => {
        state.loading = false
        state.selectedOrganisation = action.payload
      })
      .addCase(fetchModuleByID.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })

    //   // Update Organisation
      .addCase(updateModules.fulfilled, (state, action) => {
        if (!action.payload?.id) return
        state.modulesList = state.modulesList.map(org =>
          org.id === action.payload.id ? action.payload : org
        )
      })
      .addCase(updateModules.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to update organisation'
      })
      .addCase(updateModulesStatus.rejected, (state, action) => {
        state.loading = false
        state.error =
          action.error.message || 'Failed to update organisation status'
      })
  }
})

export default modulesSlice.reducer
